import React from "react";
import PropTypes from "prop-types";
import CustomModal from "components/Modal";
import Button from "components/Button";
import "./index.scss";

const LearnMore = ({ algorithmInfo, isOpen, onClose }) => {
  const handleOnClose = () => {
    onClose();
  };

  return (
    <CustomModal
      isOpen={isOpen}
      size="medium"
      onClose={handleOnClose}
      onRequestClose={handleOnClose}
      blurred
    >
      <div className="learn-more" data-testid="learn-more-modal-content">
        <h3 className="title">{algorithmInfo?.title}</h3>
        <div className="paragraph">{algorithmInfo?.description}</div>
        <Button
          type="outlined"
          color="white"
          id="ok-button"
          label="Got it"
          block
          onClick={handleOnClose}
        />
      </div>
    </CustomModal>
  );
};

LearnMore.propTypes = {
  algorithmInfo: PropTypes.shape({
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
  }).isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default LearnMore;
